import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const classNames = require('classnames');

import { S_CircleCheck } from 'hosman-material';
import { Modal, Button } from 'hosman-material';

import VALUATIONS from '../../../../../../../api/ressources/SellerApp/valuations';

const EstimationReview = ({ valuation, setValuation, inZone, expert }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const estimationReviews = [
    { slug: 'too_low', text: 'Trop basse' },
    { slug: 'accurate', text: 'Juste' },
    { slug: 'too_high', text: 'Trop haute' },
  ]

  const updateOpinionValuation = async ({ valuationId, params }) => {
    let response = await VALUATIONS.updateValuation(valuationId, params)
    setValuation(response.data)

    if (params.opinion !== 'accurate' && expert?.phone_calendar_link) {
      setModalOpen(true);
    }
  }

  const optionClasses = (slug) => {
    return classNames(
      `text-ih-indigo bg-white text-sm font-semibold p-3 rounded-2xl cursor-pointer border transition ease-in-out duration-300 ${valuation.opinion ? 'opacity-0 z-0' : 'opacity-100 z-10'}`,
      { 'hover:border-ih-blue-80 hover:bg-ih-blue-10': valuation.opinion !== slug }
    );
  }

  return(
    <div className='flex flex-col justify-center items-center gap-2' data-testid='EstimationReview'>
      {!valuation.opinion && <p className='text-center text-ih-indigo font-semibold text-sm'>Que pensez-vous de cette estimation ?</p>}

      <div className='flex justify-center items-center flex-wrap gap-2 relative'>
        {estimationReviews.map(({ slug, text }) => {
          return (
            <div key={slug} className={optionClasses(slug)} onClick={() => updateOpinionValuation({ valuationId: valuation.id, params: { opinion: slug }})} data-testid='opinionOption'>
              {text}
            </div>
          )
        })}

        <div className={`text-ih-indigo-50 text-sm p-3 transition duration-300 absolute ease-in-out ${valuation.opinion ? 'opacity-1 z-10' : 'opacity-0 z-0'}`} data-testid='opinionSentMsg'>
          <div className='flex justify-center items-center gap-1'>
            <FontAwesomeIcon icon={S_CircleCheck} className='text-ih-green' />
            <p>Merci pour votre retour.</p>
          </div>

          {inZone && <p>Un rendez-vous physique avec un agent local permettra d'affiner au plus juste cette première estimation.</p>}
        </div>
      </div>

      <Modal isOpen={modalOpen} closeModal={() => setModalOpen(false)} width='w-full md:w-2/3'>
        <div className='flex flex-col md:flex-row-reverse'>
          <img
            src='https://res.cloudinary.com/vesta-home/image/upload/v1782293109/assets/images/pages/experts/leo_rdv_estim.webp'
            alt="Agent Hosman en rdv d'estimation"
            className='w-full md:w-1/2 object-cover'
          />

          <div className='flex flex-col gap-8 p-6 md:p-8 justify-center'>
            <div className='flex flex-col gap-2'>
              <p className='h2 text-ih-indigo'>Votre bien nécessite une analyse plus approfondie</p>
              <p className='text-sm text-ih-indigo-60'>La première estimation reste indicative : elle est calculée automatiquement par un algorithme, à partir des informations renseignées dans le formulaire.</p>
            </div>

            <div className='bg-ih-blue-10 border border-ih-blue-20 rounded-2xl p-6 flex flex-col gap-4'>
              <div className='flex flex-col gap-2'>
                <p className='font-semibold text-ih-indigo'>Comment affiner votre estimation ?</p>
                <p className='text-sm text-ih-indigo-60'>Réservez un rendez-vous téléphonique avec l'un de nos conseillers pour lui présenter votre projet et votre bien. Il organise ensuite une visite d'estimation en physique, à l'issue de laquelle vous recevez une estimation précise et argumentée.</p>
              </div>

              {expert?.phone_calendar_link &&
                <Link to={expert.phone_calendar_link} target='_blank'>
                  <Button label='Prendre un RDV' />
                </Link>
              }
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
};

export default EstimationReview;
